module.exports = __webpack_public_path__ + "static/undraw_wind_turbine_x2k4-be2215be9809ad776becb8835f7f3b2b.svg";